import { render } from "./ModalComponentsOrdersActionUndo.vue?vue&type=template&id=f81399b6"
import script from "./ModalComponentsOrdersActionUndo.vue?vue&type=script&lang=js"
export * from "./ModalComponentsOrdersActionUndo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__